<template>
  <div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
    <notifications></notifications>
    <side-bar>
      <user-menu ref="userMenu"></user-menu>
      <template slot="links">
        <sidebar-item :link="{
          name: $t('ANA_SƏHİFƏ'), 
          icon: 'fa-solid fa-house',
          path: '/dashboard',
        }">
        </sidebar-item>

        <sidebar-item :link="{
          name: $t('Soraqçalar'),
          icon: 'fa-solid fa-file-contract',
        }">
          <sidebar-item :link="{ name: $t('Müqavilələr'), path: '/adm/contract' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('Təsdiqləyicilər'), path: '/adm/create-signer' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{
          name: $t('ÇAĞRI_MƏRKƏZİ'),
          icon: 'fa-solid fa-headphones-simple',
        }">
          <sidebar-item :link="{ name: $t('Müraciətlər'), path: '/callcenter/main' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('Axtarış'), path: '/callcenter/all/accidents' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{
          name: $t('QƏZA_KOMİSSARI'),
          icon: 'fa-solid fa-person-military-pointing',
        }">
      <sidebar-item :link="{ name: $t('Cari_hadisələr'), path: '/comm/main' }"></sidebar-item>
<sidebar-item :link="{ name: $t('Axtarış'), path: '/comm/all/accidents' }"></sidebar-item>
<sidebar-item :link="{ name: $t('Təsdiq'), path: '/adm/commapprove' }"></sidebar-item>
<sidebar-item :link="{ name: $t('Komissarların_İş_qrafiki'), path: '/comm/schedule' }"></sidebar-item>
<sidebar-item :link="{ name: $t('Komissarların_ərazi_bölgüsü'), path: '/comm/commregion' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: $t('MÜŞTƏRİ_XİDMƏTLƏRİ'), icon: 'fas fa-people-carry' }">
          <sidebar-item :link="{ name: $t('Cari_hadisələr'), path: '/servicecenter/main' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('Açıq_işlər'), path: '/servicecenter/active-claims' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('Axtarış'), path: '/servicecenter/accidents' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('İcraçı təyinatı'), path: '/adm/client-service-assignments' }"></sidebar-item>
        </sidebar-item>
        <sidebar-item :link="{ name: $t('QİYMƏTLƏNDİRMƏ'), icon: 'fa-solid fa-wrench' }">
          <sidebar-item :link="{ name: $t('Cari_işlər'), path: '/techexpert/claims' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('Axtarış'), path: '/techexpert/all/claims' }"></sidebar-item>
        </sidebar-item>
    

        <sidebar-item :link="{
          name: $t('TƏSDİQLƏNMƏ'),
          icon: 'fa-solid fa-person-circle-check',
          path: '/approval/main',
        }"></sidebar-item>
        <sidebar-item :link="{
          name: $t('ÖDƏNİŞ'),
          icon: 'fa-solid fa-money-check',
          path: '/payment/main',
        }">
          <sidebar-item :link="{ name: $t('Cari_işlər'), path: '/payment/main' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('Axtarış'), path: '/payment/all/claims' }"></sidebar-item>
        </sidebar-item>

        <sidebar-item :link="{
          name: $t('HESABAT'),
          icon: 'fa-solid fa-file-contract',
        }">
          <sidebar-item :link="{ name: $t('Hadisələrin_təhlili_Power_Bi'), path: '/report/powerbi' }"></sidebar-item>

          <sidebar-item :link="{ name: $t('Hadisə_sayları'), path: '/report/accidentcount' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('BTZ_hadisələri'), path: '/report/accidentbtz' }"></sidebar-item>
          <sidebar-item :link="{ name: $t('Hadisələrin_məlumatları'), path: '/report/accidentDetails' }"></sidebar-item>
          <sidebar-item
            :link="{ name: $t('Hadisələrin_detalları'), path: '/report/accidentFullDetails' }"></sidebar-item>

        </sidebar-item>

        <sidebar-item :link="{
          name: $t('Carep'),
          icon: 'fa-solid fa-wrench',
        }">
          <sidebar-item :link="{ name: $t('Təmir_mərkəzlərinin_idarəsi'), path: '/carep' }"></sidebar-item>

        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <dashboard-content @click.native="closeSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<script>
  import TopNavbar from "./TopNavbar.vue";
  import ContentFooter from "./ContentFooter.vue";
  import DashboardContent from "./Content.vue";
  import UserMenu from "./UserMenu.vue";

  function hasElement(className) {
    return document.getElementsByClassName(className).length > 0;
  }

  function initScrollbar(className) {
    if (hasElement(className)) {
    } else {
      setTimeout(() => {
        initScrollbar(className);
      }, 100);
    }
  }

  export default {
    components: {
      TopNavbar,
      ContentFooter,
      DashboardContent,
      UserMenu,
    },
    methods: {
      onDashboardClick() {
        if (this.$sidebar.showSidebar) {
          this.$sidebar.displaySidebar(false);
          return;
        }
        const userMenu = this.$refs.userMenu;
        if (userMenu && userMenu.isClosed) {
          userMenu.isClosed = false;
        }
      },
          closeSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },
      initScrollbar() {
        let docClasses = document.body.classList;
        let isWindows = navigator.platform.startsWith("Win");
        if (isWindows) {
          initScrollbar("main-panel");

        } else {
        }
      },
    },
    mounted() {
      this.initScrollbar();
    },
  };
</script>
<style scoped>
  .main-panel {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    overflow-x: hidden;
  }

  .content {
    flex: 1;
    padding: 20px;
    overflow-y: auto;
  }

  .footer {
    position: sticky;
    bottom: 0;
  }
</style>